import { config } from '../../config.js';
import { doRequest } from '../../http/request.js';

const { API_URL } = config;

/**
 * Add equipment
 *
 * @param versionId
 * @param equipmentId
 * @param config
 * @returns {Promise<*>}
 */
export const addEquipment = async (versionId, equipmentId, config = null) => {
    const url = `${API_URL}/dkwp/v1/add-equipment`;

    const response = await doRequest(url, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8',
        },
        body: JSON.stringify({
            versionId,
            equipmentId,
            config,
        }),
    });

    return await response.json();
};

/**
 * Remove equipment
 *
 * @param versionId
 * @param equipmentId
 * @param config
 * @returns {Promise<*>}
 */
export const removeEquipment = async (versionId, equipmentId, config = null) => {
    const url = `${API_URL}/dkwp/v1/remove-equipment`;

    const response = await doRequest(url, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8',
        },
        body: JSON.stringify({
            versionId,
            equipmentId,
            config,
        }),
    });

    return await response.json();
};
